import PropTypes from 'prop-types';

import './ConfirmModal.css';

import { buildClass } from '../../../libs/classes';
import ModalBase from '../ModalBase';
import SimpleButton, { ButtonTypes } from '../../SimpleComponents/SimpleButton';

const DEFAULT_TITLE = 'Confirmation';
const confirmModalStyles = {
	content: {
		top: '250px',
		width: '400px',
	},
};

/**
 * Confirmation dialog.
 * @component
 */
const ConfirmModal = ({ isOpen, title = DEFAULT_TITLE, defaultYes = false, onResult, className, children }) => {
	return (
		<ModalBase
			className={String(buildClass('modal-confirm', className))}
			isOpen={isOpen}
			style={confirmModalStyles}
			onRequestClose={handleNo}
		>
			<div className="modal-header">
				<div className="modal-title">{title}</div>
				<div className="modal-close-x" onClick={handleNo} />
			</div>
			<div className="modal-content">{children}</div>
			<div className="modal-control">
				<div className="buttons-wrapper">
					<SimpleButton
						autoFocus={defaultYes ? true : false}
						title="Confirm"
						type={ButtonTypes.DEFAULT}
						value="Confirm"
						onClick={handleYes}
					/>
					<SimpleButton
						autoFocus={defaultYes ? false : true}
						title="Cancel"
						type={ButtonTypes.GREY}
						value="Cancel"
						onClick={handleNo}
					/>
				</div>
			</div>
		</ModalBase>
	);

	function handleYes() {
		onResult(true);
	}
	function handleNo() {
		onResult(false);
	}
};

ConfirmModal.propTypes = {
	// Open state of modal
	isOpen: PropTypes.bool.isRequired,
	// Additional class name
	className: PropTypes.string,
	// Title for modal (Default: "Confirmation")
	title: PropTypes.string,
	// "Yes" button is in focus when the modal is opened
	defaultYes: PropTypes.bool,
	// Callback function on result confirmation
	onResult: PropTypes.func.isRequired,
	// Modal content
	children: PropTypes.node.isRequired,
};

export default ConfirmModal;
